package dev.danko.roblox_craft_ai.shared.model

import kotlinx.serialization.Serializable

@Serializable
enum class AssetType {
    LUAU_SCRIPT,
    MESH_3D,
    ANIMATION,
    ROJO_PROJECT
}
